import walletSlice from './slice';

export default walletSlice.reducer;
